import { Component } from "react";
import "../css/bootstrap.css";
import $ from "jquery";
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import { saveItCareerForm } from "../service";

class PoweredBy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditorPoweredByActive: "0",
            PowerdByArray: [],
            PowerdByArrayList: [],
            PowerdByArrayTextstate: ""

        }
    }
    componentDidMount() {
        this.setState({
            PowerdByContentId: this.props.PowerdByArray[0].contentDataId,
            PowerdByArrayList: this.props.PowerdByArray[0].listing,
        });
        if (this.props.PowerdByArray[0].listing.length > 0) {
            this.setState({
                PowerdByArrayTextstate: this.props.PowerdByArray[0].listing[0].contentDataSubSubtitle,
            })
        }
    }
    save() {
        var flag = true
        if ($("#poweredByinputTxt").val() === '') {
            alert("Enter Text")
            return false;
        }
        if (flag == true) {
            let contentDataId = this.state.PowerdByContentId
            let description = $("#poweredByinputTxt").val()

            this.savePoweredBy(
                contentDataId,
                description,
            );
        }
    }
    savePoweredBy(
        contentDataId, description
    ) {
        const postData = {
            functionName: "saveContentDataSub",
            contentDataId: contentDataId,
            contentDataSubId: this.props.PowerdByArray[0].listing.length > 0 ? this.props.PowerdByArray[0].listing[0].contentDataSubId : "",
            contentDataSubDescription: "",
            contentDataSubTitle: "",
            siteId: "",
            contentDataSubIsApproved: "0",
            image: "",
            userRole: "SuperAdmin",
            oldImage: "",
            isSaveDraft: "0",
            contentDataSubSortOrder: "",
            pageId: "1",
            altText: "",
            h3Tag: "",
            contentDataSubSubtitle: description,
        };
        console.log("postDataaaa", postData);
        saveItCareerForm(postData).then((data) => {
            console.log("hhhhhh.....", data);
            if (data.data.success == 1) {
                this.props.getData()
                this.cancelPoweredBy();
            }
        });
    }


    deletePoweredBy(mode) {
        if (mode === "delete") {
            const postData = {
                functionName: "delete",
                contentDataSubId: this.props.PowerdByArray[0].listing[0].contentDataSubId,
            };
            if (window.confirm("Do you want to delete?")) {
                saveItCareerForm(postData).then((data) => {
                    if (data.data.success == 1) {
                        this.props.getData();
                        window.location.reload();
                    }
                });
            } else {
                return false;
            }
        }
    }



    AddPoweredBy() {
        $(".bgdefault").addClass("editActive");
        this.setState({ isEditorPoweredByActive: "1" });
    }
    cancelPoweredBy() {
        $(".bgdefault").removeClass("editActive");
        this.setState({ isEditorPoweredByActive: "0" });
    }
    editPoweredBy() {
        $(".bgdefault").addClass("editActive");
        this.setState({ isEditorPoweredByActive: "1" });
        if (this.state.PowerdByArrayList.length > 0) {
            $("#poweredByinputTxt").val(this.props.PowerdByArray[0].listing[0].contentDataSubSubtitle)
        }
    }
    render() {
        return (
            <footer className="bgdefault">
                {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
                    <>
                        <div className="adminIconMain">
                            {this.props.PowerdByArray[0].listing.length == "0" ?
                                <span
                                    className="editIcon addButton"
                                    onClick={(e) => {
                                        this.AddPoweredBy();
                                    }}
                                >
                                    <img src={Add} />
                                </span>
                                :
                                <>
                                    <span
                                        class="editIcon editButton"
                                        onClick={(e) => {
                                            this.editPoweredBy();
                                        }}
                                    >
                                        <img src={Edit} />
                                    </span>
                                    {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                                    <span class="editIcon DeleteIcon"
                                        onClick={() => this.deletePoweredBy("delete")}
                                    >
                                        <img src={Delete} />
                                    </span>
                                </>
                            }
                        </div>
                        {/* <div className="adminIconLeft">
                    <div className="approveButton">Approve</div>
                    <div class="draftSpan"> Draft </div>
                    <div className="rejectSection">
                        <div class="rejectButton"> Reject </div>
                        <textarea
                            className="rejectComment"
                            placeholder="Enter Reason"
                        ></textarea>
                    </div>
                    <div className="rejectSection">
                        <div class="rejectButton"> Rejected </div>
                        <div className="rejectCommentText">Reason :</div>
                    </div>
                </div> */}
                    </>
                }
                <div className="container">
                    <div className="col-sm-12 text-center no_padding">
                        <p className="top10">
                            {console.log("this.props.PowerdByArray[0].listing[0].contentDataSubSubtitle", this.props.PowerdByArray[0].listing)}
                            {this.props.PowerdByArray[0].listing.length > 0 ?
                                this.props.PowerdByArray[0].listing[0].contentDataSubSubtitle
                                : ""}
                        </p>
                        <input type="text" placeholder="Enter Title" autocomplete="off" maxlength="80" class="editInput" id="poweredByinputTxt" />
                        <div className="editPanelButton">
                            {/* <span className="saveButton saveDraft">Save Draft</span> */}
                            <span className="saveButton" onClick={() => { this.save() }}>Submit</span>
                            <span className="cancelButton" onClick={(e) => { this.cancelPoweredBy() }}>Cancel</span>
                        </div>
                    </div>
                </div>
            </footer>

        );
    }
}
export default PoweredBy;
